<template>
  <div v-cloak>
    <v-app light class="main-page" style="background-color: #f7f7f7">
      <LeftDrawer></LeftDrawer>
      <AppBar :emailFlag="emailFlag"></AppBar>
      <v-main id="main">
        <template v-if="ready">
          <!-- <transition
                                                                                        appear
                                                                                        appear-active-class="animated slideInDown"
                                                                                        enter-active-class="animated slideInDown">
                                                                                    <IndexNotice ></IndexNotice>
                                                                                </transition> -->
          <transition name="slide" mode="out-in">
            <router-view></router-view>
          </transition>
          <!--          <Feedback v-if="clientId && clientId !== -1"></Feedback>-->

          <template v-if="$p(['account.information.bind_phone'])">
            <BindPhoneConfirm
              @hook:mounted="$root.billingCpn = $refs.updatephone"
              ref="updatephone"></BindPhoneConfirm>
          </template>
          <template v-else>
            <UpdateBillingInfo
              @hook:mounted="$root.billingCpn = $refs.updatebillinginfo"
              ref="updatebillinginfo"></UpdateBillingInfo>
          </template>
          <NewTicket v-if="clientId && clientId !== -1" ref="openTicket"></NewTicket>
          <Alerts ref="alerts" />
        </template>
        <v-overlay absolute opacity="0.1" :value="$store.state.topLoading">
          <img :src="per" />
        </v-overlay>
      </v-main>
      <!--            <v-dialog style="box-shadow: none;" :value="$store.state.topLoading" attach="#main" width="80"-->
      <!--                no-click-animation content-class="main-loading" persistent>-->
      <!--                <v-card style="background: transparent;">-->
      <!--                    <img :src="per" />-->
      <!--                </v-card>-->
      <!--            </v-dialog>-->
    </v-app>
    <Token @login="loginHook"></Token>
  </div>
</template>
<script>
import per from './assets/images/preloader.svg'
import Token from '@/components/Token.vue'
import UpdateBillingInfo from '@/views/_components/BillingInfo/update/index.vue'
import BindPhoneConfirm from '@/views/_components/BindPhoneConfirm'
import LeftDrawer from './components/core/LeftDrawer.vue'
import AppBar from './components/core/AppBar.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import NewTicket from '@/components/NewTicket.vue'
import { cloudclustersURL } from '@/module/constant'
import router from './router'
import Alerts from '@/components/alerts/index.vue'

const actor = process.env.VUE_APP_ACTOR
// const Feedback = () => import('@/components/feedback/index.vue')

const titleMap = {
  ccs: 'Easy Client Panel for Cloud Clusters',
  hwy: '云集群控制面板',
  dbm: 'Log in to Database Mart | Customer Panel'
}

export default {
  name: 'App',
  components: {
    Token,
    LeftDrawer,
    AppBar,
    NewTicket,
    Alerts,
    UpdateBillingInfo,
    BindPhoneConfirm
  },
  metaInfo: {
    titleTemplate: function () {
      let match = this.$route.matched[0]
      if (match && match.meta.title) {
        return `${titleMap[actor]} - ${this.$t(match.meta.title)}`
      } else {
        return `${titleMap[actor]}`
      }
    }
  },
  data() {
    return {
      emailFlag: false,
      ready: false,
      hasLogin: false
    }
  },
  computed: {
    logoHref() {
      return cloudclustersURL
    },
    ...mapState('oAuth', ['clientId']),
    ...mapState('client', ['clientInfo'])
  },
  provide() {
    return {
      verificationAccountAccess: (type) => {
        if (!this.clientInfo) return false
        if (type === 'limits') {
          this.$refs.alerts.openLimits()
          return false
        }
        if (this.clientInfo.sub_status === 'Risk') {
          this.$refs.alerts.openRisk()
          return false
        }
        if (this.clientInfo.sub_status === 'Restricted') {
          this.$refs.alerts.openRestricted()
          return false
        }
        return true
      }
    }
  },
  methods: {
    getEmail() {
      this.$http
        .get('/emails/', {
          params: { page_size: 20 }
        })
        .then(({ assist_data }) => {
          this.emailFlag = assist_data.unread > 0
        })
        .catch((e) => {
          this.$message.error(e.detail)
        })
    },
    pushRoute() {
      if (this.clientInfo.verification_info) {
        const info = this.clientInfo.verification_info
        if (info.need_verify) {
          const parentRoute = router.options.routes.find(
            (route) => route.name === 'Account Information'
          )
          if (parentRoute) {
            if (!sessionStorage.getItem('isRedirectBlocked')) {
              this.$router.replace('/account/verify-info')
            } else {
              sessionStorage.removeItem('isRedirectBlocked')
            }
          }
        }
      }
    },
    loginHook(flag) {
      this.hasLogin = flag
      Promise.all([this.getClientInfo(), this.getProducts()])
        .then(() => {
          if (flag) {
            // 升级申请 / 消费限额失败不应卡住登录后的路由与菜单初始化
            return Promise.all([
              this.getUpgradeInfo().catch(() => null),
              this.getSpendRateLimit().catch(() => null)
            ])
          } else {
            return Promise.resolve()
          }
        })
        .then(() => {
          this.pushRoute()
          if (this.clientInfo.id !== -1) {
            this.getAvailablePackages()
            this.getTickets()
          }
          if (flag) {
            this.$SDK.setUser(this.clientInfo.id, {
              user_type: 'customer',
              country: this.clientInfo.country
            })
          }
          this.$store.commit('toggleLoading', false)
          this.ready = true
        })
        .catch((e) => {
          this.$message.error(e.detail)
        })
      flag && this.getEmail()
    },
    ...mapActions('client', ['getClientInfo', 'getUpgradeInfo', 'getSpendRateLimit']),
    ...mapMutations('application', ['setIsVerifyInfo']),
    ...mapActions('application', ['getProducts', 'getAvailablePackages']),
    ...mapActions('ticket', ['getTickets'])
  },
  created() {
    this.per = per
    document.getElementById('initLoading').style.display = 'none'
  },
  mounted() {
    this.$root.$on('closeEmailFlag', (flag) => {
      this.emailFlag = flag
    })
    this.$root.$on('newTicket', (payload) => {
      this.$refs.openTicket.open(payload)
    })
  }
}
</script>

<style lang="scss">
$body-font-family: Montserrat, 'Roboto', sans-serif !important;
.main-page {
  .main-loading {
    box-shadow: none;
  }

  // ===== 全站统一表单输入框风格 =====
  // 所有 outlined 输入框（text-field / select / autocomplete / textarea 等）统一为
  // 8px 圆角 + #e5e7eb 边框 + 灰色 label。浮动 label 沿用 Vuetify 原生缺口(notch)，
  // 背景透明、落在真实的边框缺口里，不做任何白底遮盖。
  .v-text-field--outlined {
    .v-input__control {
      border-radius: 8px;
    }

    .v-input__slot fieldset {
      border-color: #e5e7eb;
    }

    // 仅非错误态统一 label 为灰色，保留校验失败时的红色 label
    &:not(.error--text) .v-label {
      color: #6b7280;
    }

    &.v-input--is-focused .v-input__slot fieldset {
      border-color: var(--v-primary-base);
    }

    &.error--text .v-input__slot fieldset {
      border-color: var(--v-error-base);
    }
  }

  // 统一内容内边距（移除 PageContent 后补齐左右/上下留白）
  // 注意：不要改 v-main 自身 padding，它由 Vuetify 计算以避让固定 AppBar/Drawer
  #main .v-main__wrap {
    padding: 24px 30px 30px;
  }

  @media (max-width: 599px) {
    #main .v-main__wrap {
      padding: 16px 16px 24px;
    }
  }
}
</style>
